export default "assets/images/texture_black-cd71eba7.jpg";